module.exports = __webpack_public_path__ + "img/PL08348.47f3882a.png";